<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-12">
          <h6 class="h2 text-white d-inline-block mb-0">Editar Cultivo</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row justify-content-center">
        <crop-form v-if="isDataLoaded" :crop="crop" @save="saveCrop"></crop-form>
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import CropForm from './Forms/CropForm';
import swal from 'sweetalert2';

export default {
  name: 'CropsEdit',
  components: {
    RouteBreadCrumb,
    CropForm,
  },

  data() {
    return {
      crop: null,
      isDataLoaded: false,
    };
  },

  created() {
    const cropId = this.$route.params.id;
    this.fetchCrop(cropId);
  },

  methods: {
    fetchCrop(id) {
      this.$services
        .resource('crops')
        .show(id)
        .then((res) => res.data.data)
        .then((crop) => {
          this.crop = crop;
          this.isDataLoaded = true;
        });
    },

    saveCrop(updatedCrop) {
      this.$services
        .resource('crops')
        .update(this.crop.id, updatedCrop)
        .then((res) => {
          swal({
            title: 'Listo!',
            text: 'El cultivo fue actualizado.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success',
            type: 'success',
          }).then(() => this.$router.push({ name: 'CropsList' }));
        });
    },
  },
};
</script>
